import React from "react";

export default function OverlayModal({ onClose, onStartChat, onContact }) {
  return (
    <div
      style={{
        position: "fixed",
        zIndex: 1000,
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.22)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Centered Card */}
      <div
        style={{
          position: "relative",
          background: "#fff",
          borderRadius: "28px",
          width: "820px",
          maxWidth: "98vw",
          boxShadow: "0 6px 32px rgba(0,0,0,0.16)",
          padding: "44px 48px 36px 48px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxHeight: "92vh",
          overflowY: "auto",
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "28px",
            right: "28px",
            background: "#111",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            fontSize: "24px",
            lineHeight: "30px",
            cursor: "pointer",
            boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
          }}
          aria-label="Close"
        >
          &#215;
        </button>
        {/* Title */}
        <h1
          style={{
            fontSize: "34px",
            fontWeight: 700,
            marginBottom: "16px",
            textAlign: "center",
          }}
        >
          Welcome to Vibhor's AI Portfolio{" "}
          <span role="img" aria-label="wave">
            👋
          </span>
        </h1>
        {/* Subtitle */}
        <div
          style={{
            fontSize: "19px",
            color: "#444",
            marginBottom: "38px",
            textAlign: "center",
          }}
        >
          Interactive, dynamic, and built for real conversations{" "}
          <span role="img" aria-label="thoughtful">
            🧠
          </span>
        </div>
        {/* Info Content Box */}
        <div
          style={{
            width: "98%",
            background: "#f7f8fa",
            borderRadius: "18px",
            padding: "30px 32px",
            marginBottom: "35px",
          }}
        >
          <div style={{ fontWeight: "600", fontSize: "21px", marginBottom: "16px" }}>
            What's this?
          </div>
          <div style={{ fontSize: "15px", marginBottom: "26px" }}>
            Welcome to my <span style={{ fontWeight: "600" }}>interactive AI portfolio</span> — a space where you don’t just scroll, you engage. Think of it as a conversation between you and my AI avatar. Whether you're a recruiter, engineer, or just curious — you’re in control.
          </div>
          <div style={{ fontWeight: "600", fontSize: "21px", marginBottom: "16px" }}>
            Why build it this way?
          </div>
          <div style={{ fontSize: "15px" }}>
            Portfolios should reflect what you do — not just what you say. Since I build LLM tools, agents, and RAG pipelines, I wanted my portfolio to be as smart and interactive as the products I create. So instead of a static website, you get a dynamic experience — powered by my own code and creativity.
          </div>
        </div>
        {/* Action Button */}
        <button
          style={{
            background: "#111",
            color: "#fff",
            borderRadius: "26px",
            fontSize: "18px",
            padding: "14px 46px",
            fontWeight: "600",
            border: "none",
            cursor: "pointer",
            marginBottom: "14px",
            boxShadow: "0 1px 10px rgba(0,0,0,0.11)",
          }}
          onClick={() => {
            onStartChat();
          }}
        >
          Start Chatting
        </button>
        {/* Bottom Contact Line */}
        <div
          style={{
            textAlign: "center",
            fontSize: "14px",
            color: "#6464bc",
            marginTop: "4px",
          }}
        >
          Like what you see? Let's talk!{" "}
          <button 
            onClick={onContact}
            style={{ 
              color: "#3584e4", 
              textDecoration: "underline", 
              fontWeight: 500,
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "14px",
              padding: 0
            }}
          >
            Contact me.
          </button>
        </div>
      </div>
    </div>
  );
}
